import { render, staticRenderFns } from "./EditOrganizationName.vue?vue&type=template&id=657c9a2c&"
import script from "./EditOrganizationName.vue?vue&type=script&lang=js&"
export * from "./EditOrganizationName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports